import { reactive } from 'vue'
import { type IntegratorPluginOptions } from '#src/types/index'

const options = reactive<IntegratorPluginOptions>({
  type: undefined,
})

export function useIntegratorPluginOptions() {
  // Expose an updater for convenience
  const updateOptions = (opts: Partial<IntegratorPluginOptions>) => {
    Object.assign(options, opts)
  }
  return { options, updateOptions }
}
